export const classifyQuestions = (questions) => {
  return questions.map((q) => {
    let importance = "low";
    let type = "distribution";

    // HIGH VALUE SIGNALS
    if (q.type === "boolean") importance = "high";
    if (q.optionBreakdown?.length > 2) importance = "medium";
    if (q.totalAnswered > 50) importance = "high";

    // DETECT STRONG WINNER
    const top = q.optionBreakdown?.[0];
    if (top?.pct > 70) type = "dominant";

    return {
      ...q,
      meta: {
        importance,
        type,
      },
    };
  });
};

export const buildSummaryCandidates = (data) => {
  const completion = data.completionStats;

  return [
    {
      key: "completion_rate",
      importance: "critical",
      title: "Completion Rate",
      value: `${completion.submittedAtLeastOnePct}%`,
      sub: `${completion.completedRatio} guests`,
    },
    {
      key: "top_preference",
      importance: "high",
      derived: true,
    },
  ];
};

export const getInsightColor = (card) => {
  const category = card?.category?.toLowerCase() || "";
  const title = card?.title?.toLowerCase() || "";

  // CATEGORY BASED COLORS

  if (category.includes("dining") || title.includes("culinary")) return "#10b981"; // green

  if (category.includes("lifestyle") || title.includes("morning")) return "#f59e0b"; // amber

  if (title.includes("evening")) return "#6366f1"; // indigo

  if (category.includes("experience") || title.includes("neighborhood")) return "#06b6d4"; // cyan

  if (category.includes("service") || title.includes("concierge")) return "#10b981"; // light green

  if (category.includes("room") || title.includes("temperature")) return "#ef4444"; // red-ish (temperature feel)

  if (category.includes("pets")) return "#8b5cf6"; // purple

  return "#1B2E24";
};
